<template>
  <div class="bar_wrapper">
    <span class="bar active"></span>
    <span class="bar active"></span>
    <span class="bar active"></span>
    <span class="bar"></span>
    <span class="bar"></span>
    <span class="bar"></span>
  </div>
  <div class="img"></div>
  <div class="question_wrapper">
    <div class="question_number">Q3</div>
    <p class="question_text">今週どれくらい働きました…？</p>
  </div>
  <div class="input_container" v-on:click="next('a')">3分くらい</div>
  <div class="input_container" v-on:click="next('b')">週2〜5日くらい</div>
  <div class="input_container" v-on:click="next('c')">2000時間くらい</div>
</template>

<script>
export default {
  name: "question3",
  methods: {
    next(input_value) {
      let point = 0;
      let is_syachiku = false;
      let normal_point = 0;

      if (input_value == "a") {
        normal_point += 1;
      }

      if (input_value == "c") {
        is_syachiku = true;
      }

      this.$emit("next", point, normal_point, is_syachiku);
    },
  },
};
</script>

<style scoped>
.img {
  background-image: url("../../assets/img/question/question_3.png");
}
</style>
